var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"contacto-player"}},[_c('BackgroundLoader',{attrs:{"source":_vm.source,"folder":"backgrounds"}}),_c('div',{staticClass:"bloque-texto",class:_vm.clase,domProps:{"innerHTML":_vm._s(_vm.texto)}}),_c('div',{staticClass:"email",on:{"click":_vm.sendMail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }